// BoldLink.js
import React from 'react';
import './BoldLink.css';

const BoldLink = ({to, children}) => {
  return <a href={to} className='boldlink'>{children}</a>
}

export default BoldLink;
